import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { Legacy_Dropdown } from '../../../legacy-dropdown/Dropdown.mjs';

const OptionDescription = forwardRef(({ children, ...props }, ref) => {
  return /* @__PURE__ */ jsx(Legacy_Dropdown.ItemDescription, { ref, ...props, children });
});

export { OptionDescription };
//# sourceMappingURL=OptionDescription.mjs.map
